<template>
	<div class="Companycultrue">
		<div class="Companycultrue-top">
			<div class="Companycultrue-top-img">
				<img
					:src="require('@/assets/images/Companycultrue-top.png')"
					class="image-width"
					alt=""
				/>
			</div>
		</div>
		<div class="Companycultrue-onebox">
			<div class="Companycultrue-mid">
				<div class="Companycultrue-mid-img">
					<img
						:src="require('@/assets/images/Companycultrue-mida.png')"
						class="image-width"
						alt=""
					/>
				</div>
				<div class="Companycultrue-mid-text">
					<span class="mid-text-left">{{ $t('企业') }}</span>
					<span>{{ $t('文化') }}</span>
				</div>
			</div>
			<div class="Companycultrue-showimg">
				<img
					:src="require('@/assets/images/Companycultrue-culture.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Companycultrue-title">
				<div>{{ $t('诚信勤勉、科技创新、成就人才') }}</div>
				<div>{{ $t('开放融合、行稳致远、追求卓越') }}</div>
			</div>
			<div class="Companycultrue-text">
				{{
					$t(
						'三环集团秉承以人为本的管理理念，形成了“诚信勤勉、科技创新、成就人才、开放融合、行稳致远、追求卓越”的企业价值观。从人才培养、职业操守、成本效益、法规制度、资源共享、质量第一、服务用户、团队精神等多方面诠释三环的人文内涵。'
					)
				}}
			</div>
		</div>
		<div class="Companycultrue-twobox">
			<div class="Companycultrue-twobox-mid">
				<div class="twobox-mid-img">
					<img
						:src="require('@/assets/images/Companycultrue-midb.png')"
						class="image-width"
						alt=""
					/>
				</div>
				<div class="twobox-mid-text">
					<span class="mid-text-left">{{ $t('发展') }}</span>
					<span>{{ $t('战略') }}</span>
				</div>
			</div>
			<div class="Companycultrue-twobox-img">
				<img
					:src="require('@/assets/images/Companycultrue-dev.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Companycultrue-twobox-text">
				<div class="twobox-text-con">
					<div class="twobox-text-line">
						{{ $t('坚持永不停步的创新动力，开拓可持续发展的产品方向') }}
					</div>
					<div class="twobox-text-line">
						{{ $t('坚持永不停步的创新动力，开拓可持续发展的产品方向') }}
					</div>
				</div>
			</div>
		</div>
		<div
			class="Companycultrue-textbox"
			v-for="(item, index) in datalist"
			:key="index"
		>
			<div class="Companycultrue-textbox-item">
				<div class="textbox-item-img">
					<img :src="item.img" class="image-width" alt="" />
				</div>
				<div class="textbox-item-title">
					{{ getLangText(item, 'title') }}
				</div>
				<div class="textbox-item-text">
					{{ getLangText(item, 'text') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			datalist: [
				{
					title: this.$t('科技创新'),
					img: require('@/assets/images/Companycultrue-create.png'),
					text: this.$t(
						'建设创新型企业，构建和谐家园是三环文化的核心。 公司设立技术、管理创新奖励，鼓励全体员工发挥创造力，参与技术、管理创新项目， 为受聘技术职务人员提供技术津贴、无息购房借款、出国旅游、外出学习等福利。'
					)
				},
				{
					title: this.$t('人才理念'),
					img: require('@/assets/images/Companycultrue-rc.png'),
					text: this.$t(
						'公司安排专车接送员工上下班，为员工提供自助式用餐，建设藏书5万多册的图书馆、为员工免费提供学习资料和场所，创办刊物《三环之光》等，为企业文化传播搭建平台。'
					)
				},
				{
					title: this.$t('人才理念'),
					img: require('@/assets/images/Companycultrue-live.png'),
					text: this.$t(
						'公司经常组织各类职业技能竞赛、文体竞赛，举办游园活动、大型文艺晚会，丰富员工的文体生活。建设“揽园”“榕湖”等多个景区，为员工提供优美的工作、休闲环境。建设了篮球场、室内恒温游泳馆、健身场等，为员工提供良好的运动场所。'
					)
				},
				{
					title: this.$t('人才培养'),
					img: require('@/assets/images/Companycultrue-people.png'),
					text: this.$t(
						'为人才创造优越的生活条件，提供平台鼓励激发人才创造业绩，增加员工收入；为股东、为社会不断增加回报，这是三环集团肩负的社会责任与历史使命。'
					)
				}
			]
		};
	}
};
</script>

<style lang="scss">
@use './Companycultrue.scss';
</style>
